<template>
  <div>
    <!-- <h4 class="text-primary mb-4">{{mins}}</h4> -->
    <!-- <av-media :media="media" line-color="#6C63FF" :frequ-lnum="20" :line-width="2" :connectDistination="false" type="frequ" :frequ-line-cap="true" :canv-height="200" :fft-size="1024"></av-media> -->
    <LoadingButton key="uploading-button" v-if="uploading" :loading="true" variant="primary" @click="record_audio">Record</LoadingButton>
    <LoadingButton key="recording-button" v-else-if="!recording" :loading="false" variant="primary" @click="record_audio">Record</LoadingButton>
    <b-button v-else variant="primary" @click="stop_audio">Stop</b-button>
    <VueRecordAudio @result="on_audio" class="audio_recorder" ref="recorder" hidden/>

    <Audio v-if="src && !recording" :source="src" class="ml-2"/>
  </div>
</template>

<script>
import { db, storage } from '@/main.js'
import moment from 'moment/src/moment'
import Audio from "@/components/Audio.vue"
import { VueRecordAudio } from "@codekraft-studio/vue-record"

// TODO max audio length

export default {
  props: ['upload_prefix', 'on_complete', 'existing_audio'],
  components: {Audio, VueRecordAudio},
  data() {
    return {
      seconds: 0,
      interval: undefined,
      recording: false,
      media: undefined,
      uploading: false,
      src: this.existing_audio
    }
  },
  mounted() {
    this.seconds = 0
    this.get_media()
  },
  beforeDestroy() {
    if (this.media) {
      try {
        this.media.getTracks().forEach(function(track) {
          track.stop()
        });
      } catch(err) {
        console.warn(err)
      }
    }
  },
  computed: {
    mins() {
      return moment("2015-01-01").startOf('day').seconds(this.seconds).format('mm:ss')
    }
  },
  methods: {
    async get_media() {
      let media = await navigator.mediaDevices.getUserMedia({audio: true})

      if (!media) {
        this.$swal({title: 'No media device', text: `We couldn't find a media device, please make sure you have allowed access to your camera and microphone and refresh the page`, icon: 'warning'})
      }

      this.media = media
      this.$forceUpdate()
    },
    update_time() {
      this.seconds++
    },
    record_audio() {
      this.recording = true
      this.$refs.recorder.startRecording()

      this.interval = setInterval(this.update_time, 1000)
    },
    stop_audio() {
      this.recording = false
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = undefined
      }

      this.$refs.recorder.stopRecording()
    },
    async on_audio(data) {
      let blob = window.URL.createObjectURL(data)

      this.src = blob

      this.seconds = 0

      this.on_complete(data)
    }
  },
}
</script>

<style lang="scss">

</style>
